export default "__VITE_ASSET__eb80c471__"